import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/blockchain-protocol-engine/page.tsx");
